import i18n from '@/i18n';

export default () => [
  {
    key: 'name',
    label: i18n.global.t('sort.sourceName'),
    value: ['name', 'string'],
  },
  {
    key: 'createdAt',
    label: i18n.global.t('sort.createdAt'),
    value: ['createdAt', 'string'],
  },
];
